import { Phone } from "lucide-react";
import { SITE } from "../config/site";
import { LogoMark } from "./Logo";

const Footer = () => (
    <footer className="border-t border-slate-800 py-16">
        <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
                <div>
                    <p className="flex items-center gap-4 font-serif text-4xl sm:text-5xl text-slate-50 tracking-tight" data-testid="footer-brand">
                        <LogoMark size={52} />
                        {SITE.brand}
                    </p>
                    <p className="mt-4 max-w-sm text-sm text-slate-500 leading-relaxed">
                        Ripetizioni di matematica e fisica per scuole medie e
                        superiori. Online ovunque e a domicilio a Livorno.
                    </p>
                </div>
                <div className="space-y-3 font-mono text-sm text-slate-400">
                    {SITE.tutors.map((t) => (
                        <a
                            key={t.id}
                            data-testid={`footer-phone-${t.id}`}
                            href={t.phoneHref}
                            className="flex items-center gap-3 hover:text-sky-400 transition-colors duration-300"
                        >
                            <Phone size={14} /> {t.name} — {t.phoneDisplay}
                        </a>
                    ))}
                </div>
            </div>
            <div className="mt-12 pt-8 border-t border-slate-800/70 flex flex-col sm:flex-row justify-between gap-4 font-mono text-xs text-slate-600">
                <span>© {new Date().getFullYear()} {SITE.brand} — Matematica &amp; Fisica</span>
                <span className="flex items-center gap-6">
                    <a href="/admin" data-testid="footer-admin-link" className="hover:text-sky-400 transition-colors duration-300">Area gestori</a>
                    <span>f(x) = chiamaci</span>
                </span>
            </div>
        </div>
    </footer>
);
export default Footer;
